import React from "react";

export const DataTableError = ({
  error,
  fallbackMessage,
}: {
  error: Error;
  fallbackMessage: string;
}) => {
  return (
    <div className="flex h-[70vh] items-center justify-center">
      <p className="text-error">{error?.message || fallbackMessage}</p>
    </div>
  );
};
